import React from "react";
import { gql } from "@apollo/client";
import CustomParser from "modules/CustomParser";

export function termSpecificContentCreator(
  specificTerm,
  name,
  processedQuery,
  t
) {
  if (!specificTerm) return null;

  const { taxonomy, safeLowerCasedName } = specificTerm.term;

  // Only sport & category return taxonomies as we don't need to know the others
  const termSpecificTitle = !taxonomy
    ? `${safeLowerCasedName} ${processedQuery.sport} ${processedQuery.category}`
    : taxonomy.node.name === "category"
    ? `${safeLowerCasedName}`
    : `${safeLowerCasedName} ${processedQuery.category}`;

  const { content } = specificTerm;

  if (!content) {
    throw new Error(
      `No content found. This function should not have been called. Specific term: ${specificTerm.term.safeLowerCasedName}`
    );
  }

  return {
    title: t("product:termSpecificContent", {
      name,
      title: termSpecificTitle,
    }),
    content: (
      <div key={`${name}-${content}`}>
        <CustomParser content={content} />
      </div>
    ),
  };
}

export const RELATEDTERMSCONTENTFRAGMENT = gql`
  fragment RelatedTermsContentFragment on TermContentObject {
    relatedTermsContent {
      content
      term {
        ... on TermNode {
          id
        }
        ... on TermContentNode {
          safeLowerCasedName
        }
        ... on Sport {
          taxonomy {
            node {
              name
              id
            }
          }
        }
        ... on Category {
          taxonomy {
            node {
              name
              id
            }
          }
        }
      }
    }
  }
`;
